import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import { HpvTestResultImportSummaryDto, TestResultImportDto, TestResultImportSummaryDto } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/test-result-import`;

export const getAllPcrTestResultsFromFile = (
    values: Partial<TestResultImportDto>,
    source: CancelTokenSource): Promise<TestResultImportSummaryDto> => {

  let bodyFormData = new FormData();
  Object.keys(values).forEach((key) => {
    let value = values[key as keyof TestResultImportDto];

    if (value) {
      // if (typeof value === "number") {
      //   value = value.toString();
      // }
      bodyFormData.append(key, value);
    }
  });

  return axios
      .post(`${apiUri}/pcr-tests`, bodyFormData, {cancelToken: source.token})
      .then(response => response.data);
};

export const importPctTestResults = (
    request: TestResultImportSummaryDto,
    source: CancelTokenSource): Promise<string> => {

  return axios
      .post(`${apiUri}/import/pcr-tests`, request, {cancelToken: source.token})
      .then(response => response.data);
};

export const getAllHpvTestResultsFromFile = (
    values: Partial<TestResultImportDto>,
    source: CancelTokenSource): Promise<HpvTestResultImportSummaryDto> => {

  let bodyFormData = new FormData();
  Object.keys(values).forEach((key) => {
    let value = values[key as keyof TestResultImportDto];

    if (value) {
      // if (typeof value === "number") {
      //   value = value.toString();
      // }
      bodyFormData.append(key, value);
    }
  });

  return axios
      .post(`${apiUri}/hpv-tests`, bodyFormData, {cancelToken: source.token})
      .then(response => response.data);
};

export const importHpvTestResults = (
    request: HpvTestResultImportSummaryDto,
    source: CancelTokenSource): Promise<string> => {

  return axios
      .post(`${apiUri}/import/hpv-tests`, request, {cancelToken: source.token})
      .then(response => response.data);
};
